import * as PaymentActionTypes from '../../constants/actiontypes/backoffice/payments';
import * as PaymentLoadings from '../../constants/loadings/backoffice/payments';
import Partner from '../../constants/models/backoffice/partner';

import User from '../../constants/models/user';
import * as R from 'ramda';
import { toast } from 'react-toastify';
import toastConf from '../../utils/toasterConfiguration';

import * as ToasterText from '../../constants/toasterText/backofficePartners';
import PaymentInvoice from '../../constants/models/paymentInvoice';
import InvoiceLine from '../../constants/models/InvoiceLine';



const PaymentReducer = (state = {
    isLoading: [],
    partnersInvoices: undefined,
    clientsInvoices: undefined,
    partners: undefined,
    clients: undefined,
    clientNextPage: false,
    partnerNextPage: false,
    partnerInvoiceLines: undefined,


}, action) => {
    switch (action.type) {

        case PaymentActionTypes.FETCH_CLIENTS_INVOICES_REQUEST:
            if (!state.isLoading.includes(PaymentLoadings.FETCHING_CLIENTS_INVOICES)) {
                state.isLoading = state.isLoading.concat(PaymentLoadings.FETCHING_CLIENTS_INVOICES);
            }

            return { ...state };

        case PaymentActionTypes.FETCH_CLIENTS_INVOICES_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PaymentLoadings.FETCHING_CLIENTS_INVOICES);

            // if (action.data.items.length < 100) {
            //     state.clientNextPage = false;
            // } else {
            //     state.clientNextPage = true;
            // }

            // if (state.clientsInvoices) {
            //     const moreClientInvoices = action.data.items.map(invoice => new PaymentInvoice(invoice));
            //     state.clientsInvoices = [...moreClientInvoices];
            // } else {

            //     state.clientsInvoices = action.data.items.map(invoice => new PaymentInvoice(invoice));
            // }

            state.clientsInvoices = action.data.items.map(user => new PaymentInvoice(user));
            state.totalPages = action.data.totalPages;
            state.totalRecords = action.data.totalRecords;
            state.currentPage = action.data.pageNumber + 1;
            return { ...state };

        case PaymentActionTypes.FETCH_CLIENTS_INVOICES_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PaymentLoadings.FETCHING_CLIENTS_INVOICES);
            return { ...state };

        case PaymentActionTypes.FETCH_ALL_CLIENTS_INVOICES_REQUEST:
            if (!state.isLoading.includes(PaymentLoadings.FETCHING_ALL_CLIENTS_INVOICES)) {
                state.isLoading = state.isLoading.concat(PaymentLoadings.FETCHING_ALL_CLIENTS_INVOICES);
            }

            return { ...state };

        case PaymentActionTypes.FETCH_ALL_CLIENTS_INVOICES_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PaymentLoadings.FETCHING_ALL_CLIENTS_INVOICES);

            state.clients = action.data.items.map(user => new PaymentInvoice(user));
            state.totalPages = action.data.totalPages;
            state.totalRecords = action.data.totalRecords;
            state.currentPage = action.data.pageNumber + 1;
            return { ...state };

        case PaymentActionTypes.FETCH_ALL_CLIENTS_INVOICES_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PaymentLoadings.FETCHING_ALL_CLIENTS_INVOICES);
            return { ...state };

        case PaymentActionTypes.FETCH_PARTNERS_INVOICES_REQUEST:
            if (!state.isLoading.includes(PaymentLoadings.FETCHING_PARTNERS_INVOICES)) {
                state.isLoading = state.isLoading.concat(PaymentLoadings.FETCHING_PARTNERS_INVOICES);
            }

            return { ...state };

        case PaymentActionTypes.FETCH_PARTNERS_INVOICES_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PaymentLoadings.FETCHING_PARTNERS_INVOICES);

            // if (action.data.length < 100) {
            //     state.partnerNextPage = false;
            // } else {
            //     state.partnerNextPage = true;
            // }

            // if (state.partnersInvoices) {
            //     const moreClientInvoices = action.data.items.map(invoice => new PaymentInvoice(invoice));
            //     state.partnersInvoices = [...moreClientInvoices];
            // } else {

            //     state.partnersInvoices = action.data.items.map(invoice => new PaymentInvoice(invoice));
            // }

            state.partnersInvoices = action.data.items.map(user => new PaymentInvoice(user));
            state.totalPages = action.data.totalPages;
            state.totalRecords = action.data.totalRecords;
            state.currentPage = action.data.pageNumber + 1;
            return { ...state };

        case PaymentActionTypes.FETCH_PARTNERS_INVOICES_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PaymentLoadings.FETCHING_PARTNERS_INVOICES);
            return { ...state };

        case PaymentActionTypes.FETCH_ALL_PARTNERS_INVOICES_REQUEST:
            if (!state.isLoading.includes(PaymentLoadings.FETCHING_ALL_PARTNERS_INVOICES)) {
                state.isLoading = state.isLoading.concat(PaymentLoadings.FETCHING_ALL_PARTNERS_INVOICES);
            }

            return { ...state };

        case PaymentActionTypes.FETCH_ALL_PARTNERS_INVOICES_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PaymentLoadings.FETCHING_ALL_PARTNERS_INVOICES);

            state.partners = action.data.items.map(user => new PaymentInvoice(user));
            state.totalPages = action.data.totalPages;
            state.totalRecords = action.data.totalRecords;
            state.currentPage = action.data.pageNumber + 1;
            return { ...state };

        case PaymentActionTypes.FETCH_ALL_PARTNERS_INVOICES_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PaymentLoadings.FETCHING_ALL_PARTNERS_INVOICES);
            return { ...state };

        case PaymentActionTypes.MARKPAID_PARTNER_INVOICE_REQUEST:
            if (!state.isLoading.includes(PaymentLoadings.MARKINGPAID_PARTNER_INVOICE)) {
                state.isLoading = state.isLoading.concat(PaymentLoadings.MARKINGPAID_PARTNER_INVOICE);
            }

            return { ...state };

        case PaymentActionTypes.MARKPAID_PARTNER_INVOICE_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PaymentLoadings.MARKINGPAID_PARTNER_INVOICE);

            state.partnersInvoices = state.partnersInvoices.map(partner => {

                if (partner.id === action.partnerId) {
                    partner.paid = action.data.paid;
                    return partner;
                }
                return partner;
            });
            return { ...state };

        case PaymentActionTypes.MARKPAID_PARTNER_INVOICE_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PaymentLoadings.MARKINGPAID_PARTNER_INVOICE);
            return { ...state };

        case PaymentActionTypes.FETCH_PARTNER_INVOICE_LINES_REQUEST:
            if (!state.isLoading.includes(PaymentLoadings.FETCHING_PARTNER_LINES)) {
                state.isLoading = state.isLoading.concat(PaymentLoadings.FETCHING_PARTNER_LINES);
            }

            return { ...state };

        case PaymentActionTypes.FETCH_PARTNER_INVOICE_LINES_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PaymentLoadings.FETCHING_PARTNER_LINES);

            state.partnerInvoiceLines = action.data.map(line => new InvoiceLine(line));

            return { ...state };

        case PaymentActionTypes.FETCH_PARTNER_INVOICE_LINES_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PaymentLoadings.FETCHING_PARTNER_LINES);
            return { ...state };



        default:
            return state;
    }
};
export default PaymentReducer;
//toast.success(Text.dataUpdatedSuccess, toastConf);